module.exports = __webpack_public_path__ + "img/welcome_bg.36998489.svg";